export default __webpack_public_path__ + "static/media/subscribe.934cfb9a.webp";